import React from 'react';
import {IOwnProps} from './model';
import View from './view';

export const ProductDataCard = (props: IOwnProps) => {
  return <View {...props} />;
};
